import cls from 'classnames';
import React from 'react';
import { RicosContext } from 'ricos-context';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { POLLS_ANSWER_TEXT_INPUT, POLLS_ANSWER_IMAGE, POLLS_ITEM_PERCENTAGE_PREVIEW } from '../../dataHooks.js';
import { s as styles, R as RemoveOption } from '../../RemoveOption-5414440c.js';
import { PollOptionBase } from './PollOptionBase.js';
import { LoaderIcon } from '../../assets/icons/LoaderIcon.js';
import { TextField } from '../text-field/TextField.js';
import { ImageUpload } from '../image-upload/ImageUpload.js';
import { CheckIcon } from '../../assets/icons/CheckIcon.js';
import { NonEditableIcon } from '../../assets/icons/NonEditableIcon.js';
import '../../style-inject.es-e7b07dd7.js';
import '../../assets/icons/RemoveIcon.js';
import 'ricos-schema';
import '../rce-helpers-context/index.js';
import 'prop-types';
import './types.js';
import '../poll-context/types.js';
import 'lodash';
import 'react-measure';
import 'wix-rich-content-common/libs/imageUtils';
import '../../defaults.js';
import '../../helpers.js';
import 'ricos-schema/next';
import 'wix-rich-content-editor-common';
import '../image-upload/types.js';
import '../../assets/icons/ReplaceIcon.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollListOption extends PollOptionBase {
  getCustomStyle() {
    var _a;
    const { design } = this.props;
    const borderRadius = parseInt((_a = design.options) == null ? void 0 : _a.borderRadius);
    return {
      input: {
        borderRadius
      },
      image: {
        borderRadius
      }
    };
  }
  renderViewMode() {
    var _a, _b;
    const { design, option, showResults, dark, t } = this.props;
    const { loading, checked } = this.state;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.option, styles.list, styles.cta, {
          [styles.with_image]: this.isImageEnabled() ? (_a = option.image) == null ? void 0 : _a.src.url : null,
          [styles.user_choice]: this.isUserChoice(),
          [styles.dark]: dark
        }),
        style: design.option,
        onClick: this.handleVoteClick,
        onKeyPress: this.handleVoteClick,
        "aria-label": checked ? t("Poll_Viewer_Option_AriaLabel_Checked") : t("Poll_Viewer_Option_AriaLabel_Unchecked"),
        tabIndex: this.context.tabIndex,
        role: "button"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles.overlay, {
            [styles.shown]: loading
          }),
          style: design.option
        },
        /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles.spinner, width: 36, height: 36 })
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          dataHook: POLLS_ANSWER_TEXT_INPUT,
          maxLength: 60,
          style: style.input,
          className: cls(styles.input, {
            [styles.with_result]: showResults
          }),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          startAdornment: this.isImageEnabled() && /* @__PURE__ */ React.createElement(
            ImageUpload,
            {
              dataHook: POLLS_ANSWER_IMAGE,
              className: styles.image,
              value: (_b = option.image) == null ? void 0 : _b.src.url,
              style: style.image,
              small: true
            }
          )
        },
        /* @__PURE__ */ React.createElement(
          "span",
          {
            className: styles.progress,
            style: {
              width: `${this.getVotePercentage()}%`
            }
          }
        ),
        showResults && /* @__PURE__ */ React.createElement("span", { className: styles.progress_value, "data-hook": POLLS_ITEM_PERCENTAGE_PREVIEW }, this.getVotePercentage(), "%")
      )),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles.check,
          style: {
            color: dark ? "#000" : design.poll.background
          }
        },
        /* @__PURE__ */ React.createElement(CheckIcon, { className: styles.icon })
      )
    );
  }
  renderEditMode() {
    var _a;
    const { design, option, removeEnabled, t, dark } = this.props;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.option, styles.list, {
          [styles.with_image]: this.isImageEnabled(),
          [styles.dark]: dark
        }),
        style: design.option
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          dataHook: POLLS_ANSWER_TEXT_INPUT,
          maxLength: 60,
          style: style.input,
          className: styles.input,
          value: option.title,
          disabled: !this.isEditAllowed(),
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          onChange: this.handleTitleChange,
          endAdornment: /* @__PURE__ */ React.createElement(React.Fragment, null, !this.isEditAllowed() ? /* @__PURE__ */ React.createElement(Tooltip, { content: t("Poll_Editor_Answer_Error_NoEdit_Tooltip") }, /* @__PURE__ */ React.createElement(NonEditableIcon, { className: styles.adornment_icon })) : null, removeEnabled && /* @__PURE__ */ React.createElement(RemoveOption, { onClick: this.handleRemove })),
          startAdornment: this.isImageEnabled() && /* @__PURE__ */ React.createElement(
            ImageUpload,
            {
              dataHook: POLLS_ANSWER_IMAGE,
              disabled: !this.isEditAllowed(),
              className: styles.image,
              value: (_a = option.image) == null ? void 0 : _a.src.url,
              onChange: this.handleImageChange,
              style: style.image,
              small: true
            }
          )
        }
      ))
    );
  }
}
__publicField(PollListOption, "propTypes", PollOptionBase.propTypes);
__publicField(PollListOption, "contextType", RicosContext);

export { PollListOption };
//# sourceMappingURL=PollListOption.js.map
